import DynamicCard from "../../scenes/AccountsAndFinanceManagement/Component/DynamicComponent";
import ImprestApprovalsTable from "../../scenes/HRManagemenet/ImprestApplications";
import ImprestApplicationsByUserTable from "../../scenes/HRManagemenet/ImprestByUser";
import ImprestSurrenderTable from "../../scenes/HRManagemenet/ImprestSurrender/surrendar";
import LeaveApplicationsTable from "../../scenes/HRManagemenet/LeaveApplications";
import LeaveApprovalsTable from "../../scenes/HRManagemenet/LeaveApprovals";
import PCApplicationsTable from "../../scenes/HRManagemenet/PettyCash/PCApplications";
import PCApplicationsByUserTable from "../../scenes/HRManagemenet/PettyCash/PCApplicationsByUser";
import StaffClaimsTable from "../../scenes/HRManagemenet/StaffClaim";
import StaffClaimsByUserTable from "../../scenes/HRManagemenet/StaffClaimByUser";

export const MyImprests = () => {
  return (
    <DynamicCard>
      <ImprestApplicationsByUserTable />
    </DynamicCard>
  );
};
export const ImprestApprovals = () => {
  return (
    <DynamicCard>
      <ImprestApprovalsTable />
    </DynamicCard>
  );
};
export const ImprestSurrender = () => {
  return (
    <DynamicCard>
      <ImprestSurrenderTable />
    </DynamicCard>
  );
};
export const AllPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsTable />
    </DynamicCard>
  );
};

export const MyPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsByUserTable />
    </DynamicCard>
  );
};
export const MyLeaveApplications = () => {
  return (
    <DynamicCard>
      <LeaveApplicationsTable />
    </DynamicCard>
  );
};
export const LeaveApprovals = () => {
  return (
    <DynamicCard>
      <LeaveApprovalsTable />
    </DynamicCard>
  );
};
export const StaffClaimApprovals = () => {
  return (
    <DynamicCard>
      <StaffClaimsTable />
    </DynamicCard>
  );
};
export const MyStaffClaims = () => {
  return (
    <DynamicCard>
      <StaffClaimsByUserTable />
    </DynamicCard>
  );
};



